import axios from '@/_services/axios';

export function GetAll(take, skip, search) {
  return new Promise((resolve, reject) => {
    axios
      .get(`labors/all?take=${take}&skip=${skip}&search=${search}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetLabors() {
  return new Promise((resolve, reject) => {
    axios
      .get('labors')
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function Get(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`labors/${id}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function Save(labor) {
  return Edit(labor);
}

function Edit(item) {
  let body = {
    residentialCost: item.userLaborCosts.residentialCost,
    commercialCost: item.userLaborCosts.commercialCost,
    industrialCost: item.userLaborCosts.industrialCost,
    civilEngineeringCost: item.userLaborCosts.civilEngineeringCost,
    name: item.name,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`labors/${item.id}`, body)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}
